import request from './request';
import { assign, merge, cloneDeep } from 'lodash';
import { API_URL, API_VERSION, MERCHANT_REQUEST_DEFAULTS, EXPLORE_REQUEST_DEFAULTS } from './constants';

/**
 * @function Network
 * @description Factory function to create a object that can send
 * requests to a specific resource on the server.
 */
function updateFromState(store) {
  this.state = store.getState;
}

updateFromState.prototype.auth = function (defaultOptions) {
  if (this.state().auth && this.state().auth.get('user').get('isLoggedIn')) {
    assign(defaultOptions.headers, {
      'Authorization': 'Bearer ' + this.state().auth.get('user').get('access_token')
    });
  }
  return this;
};

updateFromState.prototype.location = function (defaultOptions) {
  if (this.state().customer && this.state().customer.get('location').get('coords').size > 0) {
    assign(defaultOptions.headers, {
      'x-longitude': this.state().customer.get('location').get('coords').get('longitude'),
      'x-latitude': this.state().customer.get('location').get('coords').get('latitude')
    });
  }
  return this;
};

export var Network = function Network(store) {
  var app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'merchant';

  var state = new updateFromState(store);
  var REQUEST_DEFAULTS = app === 'merchant' ? MERCHANT_REQUEST_DEFAULTS : EXPLORE_REQUEST_DEFAULTS;

  var buildURL = function buildURL() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref.id,
        resource = _ref.resource;

    var parameters = [API_URL(), API_VERSION];

    if (resource) parameters = parameters.concat([resource]);
    if (id) parameters = parameters.concat([id]);

    return parameters.join('/');
  };

  // Default options used for every request
  var defaultOptions = {
    mode: 'cors',
    headers: {
      'Content-Type': 'application/vnd.api+json'
    }
  };

  return {

    payload: function payload(type, attributes) {
      var defaults = cloneDeep(REQUEST_DEFAULTS);
      if (attributes.id) defaults.data.id = attributes.id;

      return merge(defaults, {
        data: {
          type: type,
          attributes: attributes
        }
      });
    },

    relationshipsPayload: function relationshipsPayload(data) {
      var defaults = cloneDeep(REQUEST_DEFAULTS);

      return merge(defaults, {
        data: data
      });
    },

    /**
     * @function post
     * @description Make a POST request.
     * @param {string} path
     * @param {object} body
     * @param {object} options
     * @returns {promise}
     */
    post: function post(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      state.auth(defaultOptions).location(defaultOptions);

      return request(buildURL(path), Object.assign(options, defaultOptions, {
        method: 'POST',
        body: JSON.stringify(body)
      }));
    },

    /**
     * @function get
     * @description Make a GET request.
     * @param {string} path
     * @param {object} options
     * @returns {promise}
     */
    get: function get(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      state.auth(defaultOptions).location(defaultOptions);

      return request(buildURL(path), Object.assign(options, defaultOptions, { method: 'GET' }));
    },

    /**
     * @function patch
     * @description Make a PATCH request.
     * @param {string} path
     * @param {object} body
     * @param {object} options
     * @returns {promise}
     */
    patch: function patch(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      state.auth(defaultOptions).location(defaultOptions);

      return request(buildURL(path), Object.assign(options, defaultOptions, {
        method: 'PATCH',
        body: JSON.stringify(body)
      }));
    },

    /**
     * @function put
     * @description Make a PUT request.
     * @param {string} path
     * @param {object} body
     * @param {object} options
     * @returns {promise}
     */
    put: function put(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      state.auth(defaultOptions).location(defaultOptions);

      return request(buildURL(path), Object.assign(options, defaultOptions, {
        method: 'PUT',
        body: JSON.stringify(body)
      }));
    },

    /**
     * @function delete
     * @description Make a DELETE request.
     * @param {string} path
     * @param {object} options
     * @returns {promise}
     */
    delete: function _delete(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      state.auth(defaultOptions).location(defaultOptions);

      return request(buildURL(path), Object.assign(options, defaultOptions, { method: 'DELETE' }));
    },

    ping: function ping() {
      return request(buildURL(), { method: 'GET' });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/network.js
// module id = 591
// module chunks = 4